import { z } from 'zod';

import { DelinquentInterestSettingId, PaymentConfigId } from '../BrandedIds';
import { zodBrandedUuid } from '../utils';
import { BaseLoanIdSideEffect } from './BaseLoanIdSideEffect';

export const GenerateDelinquentInterestAppliedSideEffectContext = BaseLoanIdSideEffect.extend({
  paymentConfigId: zodBrandedUuid<PaymentConfigId>().optional(),
  delinquentInterestSettingId: zodBrandedUuid<DelinquentInterestSettingId>().optional(),
});

export const GenerateDelinquentInterestAppliedSideEffect = GenerateDelinquentInterestAppliedSideEffectContext.extend({
  type: z.literal('generateDelinquentInterestApplied'),
});
export type GenerateDelinquentInterestAppliedSideEffect = z.infer<typeof GenerateDelinquentInterestAppliedSideEffect>;
